import React from "react";
import { useForm, FormProvider as FormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { object, number, string, date, array } from "yup";
import { data } from "autoprefixer";

const validationSchema = object().shape({
  id: string().required("Membership Type ID is required."),
  buildingId: string().required("Center Location is required."),
  type: string()
    .oneOf(["Private Office", "Hot Desk", "Dedicated Desk", "2gethr Connect"])
    .required("Membership Type is required."),
  name: string().required("Company Name is required."),

  startDate: date()
    .typeError("Start Date must be a valid date")
    .required("Membership Start Date is required."),
  endDate: date()
    .typeError("End Date must be a valid date")
    .required("Membership End Date is required."),
  lockingPeriod: number()
    .typeError("Locking Period must be a number")
    .optional()
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Locking Period must be a number").required(),
    }),
  annualEscalation: number()
    .typeError("Annual Escalation must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Annual Escalation must be a number").required(),
    }),
  securityDeposit: number()
    .typeError("Security Deposit must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Security Deposit must be a number").required(),
    }),
  workStationSeats: number()
    .typeError("Work Station Seats must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number()
        .typeError("Work Station Seats must be a number")
        .required(),
    }),
  additionalServices: array().of(
    object().shape({
      // id: string().required(),
      rate: number().required(),
      name: string().required(),
      endDate: date().required(),
      startDate: date().required(),
      quantity: number().required(),
    })
  ),

  collabAreaSeats: number().typeError("Collab area seats must be a number"),
  meetingRoomSeats: number().typeError("Meeting room seats must be a number"),
  onboardingCharges: number().typeError("Onboarding charges must be a number"),
  exitCharges: number().typeError("Exit charges must be a number"),

  rate: number()
    .typeError("Rate must be a number")
    .required("Price /work unit/ month is required."),
});

const AddMembershipContext = ({ children }) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      workStationSeats: 0,
      collabAreaSeats: 0,
      meetingRoomSeats: 0,
      onboardingCharges: 0,
      exitCharges: 0,
      lockingPeriod: 0,
      securityDeposit: 0,
      annualEscalation: 0,
      rate: 0,
      totalDayPasses: 0,
      meetingRoomCredits: 200,
      // type: "2gethr Connect",
    },
    // mode: "onChange",
    // context: validationSchema,
    // shouldUnregister: false,
  });

  return <FormContext {...methods}>{children}</FormContext>;
};

export default AddMembershipContext;
